import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Award } from 'lucide-react';
import { motion } from 'framer-motion';
export default function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section className="bg-gradient-to-b from-brand-cream to-brand-cream-dark text-center pb-32" data-id="element-54">
      <div className="max-w-4xl mx-auto" data-id="element-55">
        <div className="inline-block bg-red-50 text-red-600 border border-red-200 px-4 py-1 rounded-full text-sm font-bold mb-6 animate-pulse" data-id="element-56">
          ÚLTIMA OPORTUNIDAD
        </div>

        <h2 className="text-3xl md:text-4xl text-slate-900 mb-6 font-light" data-id="element-57">
          Si hoy estás cansada de decidir…
        </h2>
        <p className="text-xl md:text-2xl text-slate-500 mb-12" data-id="element-58">
          y quieres que la cena deje de ser el lugar donde se te va la poca
          energía que te queda:
        </p>

        <div className="flex justify-center mb-12" data-id="element-59">
          <img src="https://cdn.magicpatterns.com/uploads/fYe1hLq9ZUZzwjVWzEganH/banner-25671.png" alt="CERO DECISIONES" className="w-64 md:w-80 animate-float drop-shadow-xl" data-id="element-60" />
        </div>

        <div className="mb-6 transform hover:scale-105 transition-transform duration-300" data-id="element-61">
          <Button size="xl" pulse={true} className="text-2xl md:text-3xl px-16 py-8 shadow-[0_0_40px_rgba(22,163,74,0.3)] hover:shadow-[0_0_60px_rgba(22,163,74,0.5)] transition-shadow duration-300" onClick={scrollToPricing} data-id="element-62">
            HOY ELIJO NO DECIDIR MÁS →
          </Button>
        </div>

        <p className="text-slate-600 text-base font-medium mb-2" data-id="element-63">
          Solo $6.39 — y nunca más «¿qué hago de cenar?»
        </p>

        <div className="flex flex-wrap justify-center gap-4 sm:gap-8 mb-12 text-slate-500 text-sm font-medium" data-id="element-64">
          <div className="flex items-center gap-2" data-id="element-65">
            <ShieldCheck size={16} className="text-brand-purple" data-id="element-66" />
            <span data-id="element-67">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-68">
            <Zap size={16} className="text-brand-amber" data-id="element-69" />
            <span data-id="element-70">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-71">
            <Award size={16} className="text-brand-purple" data-id="element-72" />
            <span data-id="element-73">Garantía 7 días</span>
          </div>
        </div>

        <p className="text-xl text-slate-400 mb-16" data-id="element-74">
          Decide una vez. Y deja que tu semana corra.
        </p>

        <div className="relative inline-block" data-id="element-75">
          <h3 className="relative font-heading text-4xl md:text-6xl text-brand-brown leading-tight uppercase tracking-wide" data-id="element-76">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} data-id="element-77">
              Menos recetas.
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} data-id="element-78">
              Menos culpa.
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5
          }} data-id="element-79">
              Más calma.
            </motion.div>
          </h3>
        </div>

        <p className="text-slate-400 text-sm mt-12" data-id="element-80">
          ★★★★★ Valorado por más de 800 mamás
        </p>
      </div>
    </Section>;
}